<template>
  <div id="admin">
    <el-container direction="vertical">
      <el-header :height="`${headerHeight}px`" class="clearfix">
        <div style="width:50px;margin-right:10px;">
          <img src="@/assets/images/logo.png" style="width:100%" />
        </div>
        <div>
          <h1>自动驾驶管理系统</h1>
          <h1>Autopilot Management System</h1>
        </div>
        <div>
          <span>{{ loginDate }}</span>
          <el-button
            type="danger"
            icon="el-icon-switch-button"
            circle
            @click="handleLogOut"
          ></el-button>
        </div>
      </el-header>
      <el-container>
        <el-aside width="200px" :style="`min-height:${asideHeight}px;`">
          <ul class="user_info">
            <li>
              <el-avatar
                icon="el-icon-user-solid"
                :size="50"
                style="font-size:20px;"
              ></el-avatar>
            </li>
            <li>
              <p>登录名称</p>
              <span>系统管理员</span>
            </li>
          </ul>
          <ul class="tab_router">
            <li
              v-for="(item, index) in tabList"
              :class="{ active: index === tabIndex }"
              :key="index"
            >
              <a href="javascript:;" @click="handleTab(item.url, index)">{{
                item.name
              }}</a>
              <img :src="index === tabIndex ? item.imgA : item.img" />
            </li>
          </ul>
        </el-aside>
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { storage } from "@/utils/public.js";
export default {
  name: "admin",
  created() {
    this.setLoginDate();
    this.activateTabList();
  },
  data() {
    return {
      headerHeight: 50,
      loginDate: "",
      tabIndex: 0,
      tabList: [
        {
          name: "活动管理",
          url: "/activityList",
          reg: /activity/,
          img: require("@/assets/images/activityLogo.png"),
          imgA: require("@/assets/images/activityLogoA.png")
        },
        {
          name: "订购管理",
          url: "/orderList",
          reg: /order/,
          img: require("@/assets/images/orderLogo.png"),
          imgA: require("@/assets/images/orderLogoA.png")
        }
      ]
    };
  },
  methods: {
    setLoginDate() {
      const time = storage.getSession("loginDate");
      this.loginDate = time ? `登录时间： ${time}` : "";
    },
    activateTabList() {
      this.tabList.some((item, index) => {
        var bool = item.reg.test(this.$route.path);
        if (bool) {
          this.tabIndex = index;
          return true;
        }
      });
    },
    handleLogOut() {
      storage.clearAllSession();
      this.redirectByPath("/");
    },
    handleTab(url, index) {
      this.tabIndex = index;
      this.redirectByPath(url);
    }
  },
  computed: {
    asideHeight() {
      return window.innerHeight - this.headerHeight;
    }
  }
};
</script>

<style lang="less">
#admin {
  // header
  .el-header {
    border-bottom: 1px solid #000;
    color: #202239;
    background: #fff;
    div {
      float: left;
      line-height: 50px;
      &:last-child {
        float: right;
        span {
          padding-right: 10px;
          font-size: 12px;
          color: #5f717d;
        }
      }
    }
    h1 {
      font-weight: bold;
      height: 50%;
      line-height: 25px;
    }
  }
  // aside
  .el-aside {
    background: rgb(48, 65, 86);
    font-size: 16px;
    color: #b6c6d5;

    .user_info {
      padding-top: 10px;
      > li {
        margin: 10px 0 0;
        text-align: center;
        span {
          font-size: 12px;
          color: #5f717d;
        }
      }
    }
    .tab_router {
      padding-top: 10px;

      > li {
        position: relative;
        height: 50px;
        padding-left: 70px;
        line-height: 50px;
        a {
          display: block;
        }
        img {
          position: absolute;
          top: 12px;
          left: 35px;
          width: 25px;
        }
        &.active {
          background: #006aff;
          color: #fff;
        }
      }
    }
  }
  // main

  // 表格的状态颜色
  #activityList,
  #orderList {
    .query-bar {
      padding: 20px;
      margin-top: 10px;
      background: #fff;
      > div {
        padding-right: 10px;
      }
    }
    .toolbar {
      padding: 0 20px;
      background: #fff;
    }
    .query-table {
      min-height: 500px;
      padding: 20px;
      background: #fff;
      .el-table {
        font-size: 12px;
        color: #304156;
        thead tr th {
          color: #333 !important;
          background: #f8f8f6;
        }
        .clickableLink {
          color: #3280fc;
        }
        .none .auditStatus {
          color: #909399;
        }
        .waiting .auditStatus {
          color: #e6a23c;
        }
        .success .auditStatus {
          color: #67c23a;
        }
        .error .auditStatus {
          color: #f56c6c;
        }
      }
    }
  }
}
</style>
